export default __webpack_public_path__ + "static/media/logo.f551fb5f.png";